module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!-- 					<ul class="l-device-status-overview__list">\n\n						';
 if (obj.error) { 
__p+='\n						<li class="l-device-status-overview__item has-error">\n							<div class="label">Warning</div>\n							<div class="value">device error</div>\n						</li>\n						';
 } 
__p+='\n\n\n						<li class="l-device-status-overview__item">\n							<div class="label">Last seen</div>\n							<div class="value">'+
((__t=( formatTimeFromNow(getLastSeenAt()) ))==null?'':__t)+
'</div>\n						</li>\n						<li class="l-device-status-overview__item">\n							<div class="label">Rssi</div>\n							<div class="value">'+
((__t=( getSensorValue('rf') ))==null?'':__t)+
'</span></div>\n						</li>\n					</ul>\n -->\n\n					<ul class="m-sidebar-list">\n						<li class="m-sidebar-list__item">\n							<div class="list-item__inner">\n								<div class="list-item__row">\n									<span class="">Last seen</span>\n									<span class="align-right">'+
((__t=( formatTimeFromNow(getLastSeenAt()) ))==null?'':__t)+
'</span>\n								</div>\n							</div>\n						</li>\n\n						';
 if (hasSensor('signal_quality_rssi')) { 
__p+='\n							<li class="m-sidebar-list__item">\n								<div class="list-item__inner">\n									<div class="list-item__row">\n										<span class="">Rssi</span>\n										<span class="align-right">'+
((__t=( calcRssi(getSensorValue('signal_quality_rssi')) ))==null?'':__t)+
'%</span>\n									</div>\n									<div class="list-item__row">\n										<div class="m-progress">\n										<div class="m-progress__indicator" style="width:'+
((__t=( calcRssi(getSensorValue('signal_quality_rssi')) ))==null?'':__t)+
'%;"></div>\n\n									</div>\n									</div>\n								</div>\n							</li>\n						';
 } 
__p+='\n\n						';
 if (hasProperty('failsafe')) { 
__p+='\n							<!--	<li class="m-sidebar-list__item">\n									<div class="list-item__inner">\n										<div class="list-item__row">\n											<span class="">Failsafe</span>\n											<span class="align-right"><span class="m-status-indicator has-sign is-'+
((__t=( getConditionalStr(isFailSafeStatePositive(), 'positive', 'negative') ))==null?'':__t)+
'">'+
((__t=( getFailSafeStatus() ))==null?'':__t)+
'</span></span>\n										</div>\n									</div>\n								</li> -->\n						';
 } 
__p+='\n\n						';
 if (hasProperty('dyna')) { 
__p+='\n								<li class="m-sidebar-list__item">\n									<div class="list-item__inner">\n										<div class="list-item__row">\n											<span class="">Relay 1</span>\n											<span class="align-right"><span class="m-status-indicator has-sign is-'+
((__t=( getBooleanStateKind(getPropertyValue('dyna', 'relay_1_enabled')) ))==null?'':__t)+
'">'+
((__t=( getRelayState(getPropertyValue('dyna', 'relay_1_enabled')) ))==null?'':__t)+
'</span></span>\n										</div>\n									</div>\n								</li>\n								<li class="m-sidebar-list__item">\n									<div class="list-item__inner">\n										<div class="list-item__row">\n											<span class="">Relay 2</span>\n											<span class="align-right"><span class="m-status-indicator has-sign is-'+
((__t=( getBooleanStateKind(getPropertyValue('dyna', 'relay_2_enabled')) ))==null?'':__t)+
'">'+
((__t=( getRelayState(getPropertyValue('dyna', 'relay_2_enabled')) ))==null?'':__t)+
'</span></span>\n										</div>\n									</div>\n								</li>\n						';
 } 
__p+='\n\n						';
 if (hasProperty('dyna_b')) { 
__p+='\n								<li class="m-sidebar-list__item">\n									<div class="list-item__inner">\n										<div class="list-item__row">\n											<span class="">Relay 1</span>\n											<span class="align-right"><span class="m-status-indicator has-sign is-'+
((__t=( getBooleanStateKind(getPropertyValue('dyna_b', 'relay_1_enabled')) ))==null?'':__t)+
'">'+
((__t=( getRelayState(getPropertyValue('dyna_b', 'relay_1_enabled')) ))==null?'':__t)+
'</span></span>\n										</div>\n									</div>\n								</li>\n								<li class="m-sidebar-list__item">\n									<div class="list-item__inner">\n										<div class="list-item__row">\n											<span class="">Relay 2</span>\n											<span class="align-right"><span class="m-status-indicator has-sign is-'+
((__t=( getBooleanStateKind(getPropertyValue('dyna_b', 'relay_2_enabled')) ))==null?'':__t)+
'">'+
((__t=( getRelayState(getPropertyValue('dyna_b', 'relay_2_enabled')) ))==null?'':__t)+
'</span></span>\n										</div>\n									</div>\n								</li>\n						';
 } 
__p+='\n\n\n						';
 if (hasProperty('mbus')) { 
__p+='\n							<li class="m-sidebar-list__item">\n								<div class="list-item__inner">\n									<div class="list-item__row">\n										<span class="">Warmte meter</span>\n										<span class="align-right"><span class="m-status-indicator has-sign is-'+
((__t=( getConditionalStr(getPropertyValue('mbus', 'set_heat'), 'positive', 'negative') ))==null?'':__t)+
'">'+
((__t=( getConditionalStr(getPropertyValue('mbus', 'set_heat'), 'enabled', 'disabled') ))==null?'':__t)+
'</span></span>\n									</div>\n								</div>\n							</li>\n\n							<li class="m-sidebar-list__item">\n								<div class="list-item__inner">\n									<div class="list-item__row">\n										<span class="">Koude meter</span>\n										<span class="align-right"><span class="m-status-indicator has-sign is-'+
((__t=( getConditionalStr(getPropertyValue('mbus', 'set_cold'), 'positive', 'negative') ))==null?'':__t)+
'">'+
((__t=( getConditionalStr(getPropertyValue('mbus', 'set_cold'), 'enabled', 'disabled') ))==null?'':__t)+
'</span></span>\n									</div>\n								</div>\n							</li>\n\n							<li class="m-sidebar-list__item">\n								<div class="list-item__inner">\n									<div class="list-item__row">\n										<span class="">Elektriciteit meter</span>\n										<span class="align-right"><span class="m-status-indicator has-sign is-'+
((__t=( getConditionalStr(getPropertyValue('mbus', 'set_electricity'), 'positive', 'negative') ))==null?'':__t)+
'">'+
((__t=( getConditionalStr(getPropertyValue('mbus', 'set_electricity'), 'enabled', 'disabled') ))==null?'':__t)+
'</span></span>\n									</div>\n								</div>\n							</li>\n\n							<li class="m-sidebar-list__item">\n								<div class="list-item__inner">\n									<div class="list-item__row">\n										<span class="">Water meter</span>\n										<span class="align-right"><span class="m-status-indicator has-sign is-'+
((__t=( getConditionalStr(getPropertyValue('mbus', 'set_water'), 'positive', 'negative') ))==null?'':__t)+
'">'+
((__t=( getConditionalStr(getPropertyValue('mbus', 'set_water'), 'enabled', 'disabled') ))==null?'':__t)+
'</span></span>\n									</div>\n								</div>\n							</li>\n\n							<li class="m-sidebar-list__item">\n								<div class="list-item__inner">\n									<div class="list-item__row">\n										<span class="">Warmte/koude meter</span>\n										<span class="align-right"><span class="m-status-indicator has-sign is-'+
((__t=( getConditionalStr(getPropertyValue('mbus', 'set_bi'), 'positive', 'negative') ))==null?'':__t)+
'">'+
((__t=( getConditionalStr(getPropertyValue('mbus', 'set_bi'), 'enabled', 'disabled') ))==null?'':__t)+
'</span></span>\n									</div>\n								</div>\n							</li>\n					';
 } 
__p+='\n\n\n						';
 if (userHasRole ('super')) { 
__p+='\n\n							';
 if (obj.nrResets) { 
__p+='\n								<li class="m-sidebar-list__item">\n									<div class="list-item__inner">\n										<div class="list-item__row">\n											<span class="">Resets</span>\n											<span class="align-right">'+
((__t=( obj.nrResets ))==null?'':__t)+
'</span>\n										</div>\n									</div>\n								</li>\n							';
 } 
__p+='\n\n							';
 if (obj.resetReason) { 
__p+='\n								<li class="m-sidebar-list__item">\n									<div class="list-item__inner">\n										<div class="list-item__row">\n											<span class="">Reset reason</span>\n											<span class="align-right">'+
((__t=( getResetReason() ))==null?'':__t)+
'</span>\n										</div>\n									</div>\n								</li>\n							';
 } 
__p+='\n						';
 } 
__p+='\n\n						';
 if (hasProperty('identification')) { 
__p+='\n							';
 if (getPropertyValue('identification','operating_hours') > -1) { 
__p+='\n							<li class="m-sidebar-list__item">\n								<div class="list-item__inner">\n									<div class="list-item__row">\n										<span class="">Operating hours</span>\n										<span class="align-right">'+
((__t=( getPropertyValue('identification','operating_hours') ))==null?'':__t)+
'</span>\n									</div>\n								</div>\n							</li>\n							';
 } 
__p+='\n							';
 if (getPropertyValue('identification','dali_level') > -1) { 
__p+='\n							<li class="m-sidebar-list__item">\n								<div class="list-item__inner">\n									<div class="list-item__row">\n										<span class="">Dali level</span>\n										<span class="align-right">'+
((__t=( getPropertyValue('identification','dali_level') ))==null?'':__t)+
'</span>\n									</div>\n								</div>\n							</li>\n							';
 } 
__p+='\n						';
 } 
__p+='\n\n						';
 if (obj.error) { 
__p+='\n						<li class="m-sidebar-list__item is-warning">\n							<div class="list-item__inner">\n								<div class="list-item__label">Warning</div>\n								<div class="list-item__row">This device reported an error</div>\n								<div class="list-item__row"><a class="m-btn m-btn--alert js-error-reset" role="button" data-action="dialog:save-preset">reset error</a></div>\n							</div>\n						</li>\n						';
 } 
__p+='\n\n						';
 if (hasSensor('tilt')) { 
__p+='\n\n							<li class="m-sidebar-list__item">\n								<div class="list-item__inner">\n									<div class="list-item__row">\n										<span class="">Tilt angle</span>\n\n										<span class="align-right"><span class="m-status-indicator ">'+
((__t=( getSensorValue('tilt') ))==null?'':__t)+
'&deg;</span></span>\n									</div>\n								</div>\n							</li>\n\n						';
 } 
__p+='\n						';
 if (hasSensor('tilt_detect')) { 
__p+='\n\n							<li class="m-sidebar-list__item">\n								<div class="list-item__inner">\n									<div class="list-item__row">\n										<span class="">Tilt detect</span>\n										<span class="align-right"><span class="m-status-indicator has-sign is-'+
((__t=( getConditionalStr(getSensorValue('tilt_detect'), 'negative', 'positive') ))==null?'':__t)+
'">'+
((__t=( getConditionalStr(getSensorValue('tilt_detect'), 'tilted', 'normal') ))==null?'':__t)+
'</span></span>\n									</div>\n								</div>\n							</li>\n\n						';
 } 
__p+='\n\n						';
 if (userHasRole ('super')) { 
__p+='\n							';
 if (hasSensor('voltage_detect')) { 
__p+='\n								<li class="m-sidebar-list__item">\n									<div class="list-item__inner">\n										<div class="list-item__row">\n											<span class="">Voltage</span>\n											<span class="align-right"><span class="m-status-indicator has-sign is-'+
((__t=( getConditionalStr(getSensorValue('voltage_detect'), 'positive', 'negative') ))==null?'':__t)+
'">'+
((__t=( getConditionalStr(getSensorValue('voltage_detect'), 'enabled', 'disabled') ))==null?'':__t)+
'</span></span>\n										</div>\n									</div>\n								</li>\n							';
 } 
__p+='\n\n							';
 if (hasSensor('current_detect')) { 
__p+='\n								<li class="m-sidebar-list__item">\n									<div class="list-item__inner">\n										<div class="list-item__row">\n											<span class="">Current</span>\n											<span class="align-right"><span class="m-status-indicator has-sign is-'+
((__t=( getConditionalStr(getSensorValue('current_detect'), 'positive', 'negative') ))==null?'':__t)+
'">'+
((__t=( getConditionalStr(getSensorValue('current_detect'), 'enabled', 'disabled') ))==null?'':__t)+
'</span></span>\n										</div>\n									</div>\n								</li>\n							';
 } 
__p+='\n						';
 } 
__p+='\n\n						';
 if (hasSensor('novoferm')) { 
__p+='\n\n							<li class="m-sidebar-list__item">\n								<div class="list-item__inner">\n									<div class="list-item__row">\n										<span class="">Overhead value</span>\n										<span class="align-right"><span class="m-status-indicator is-'+
((__t=( getSensorValue('novoferm').state ))==null?'':__t)+
'">'+
((__t=( getSensorValue('novoferm').value ))==null?'':__t)+
'</span></span>\n									</div>\n								</div>\n							</li>\n\n						';
 } 
__p+='\n\n						';
 if (hasSensor('tamper_detect')) { 
__p+='\n\n							<li class="m-sidebar-list__item">\n								<div class="list-item__inner">\n									<div class="list-item__row">\n										<span class="">Casing</span>\n										<span class="align-right"><span class="m-status-indicator has-sign is-'+
((__t=( getConditionalStr(getSensorValue('tamper_detect'), 'negative', 'positive') ))==null?'':__t)+
'">'+
((__t=( getConditionalStr(getSensorValue('tamper_detect'), 'open', 'closed') ))==null?'':__t)+
'</span></span>\n									</div>\n								</div>\n							</li>\n\n						';
 } 
__p+='\n\n						';
 if (hasSensor('parking_detect')) { 
__p+='\n\n							<li class="m-sidebar-list__item">\n								<div class="list-item__inner">\n									<div class="list-item__row">\n										<span class="">Parking spot</span>\n										<span class="align-right"><span class="m-status-indicator has-sign is-'+
((__t=( getConditionalStr(getSensorValue('parking_detect'), 'positive', 'negative') ))==null?'':__t)+
'">'+
((__t=( getConditionalStr(getSensorValue('parking_detect'), 'available', 'occupied') ))==null?'':__t)+
'</span></span>\n									</div>\n								</div>\n							</li>\n\n						';
 } 
__p+='\n\n						';
 if (hasSensor('signal_quality_ber')) { 
__p+='\n\n								<li class="m-sidebar-list__item">\n									<div class="list-item__inner">\n										<div class="list-item__row">\n											<span class="">Bit error rate</span>\n											<span class="align-right">'+
((__t=( calcBer(getSensorValue('signal_quality_ber')) ))==null?'':__t)+
'%</span>\n										</div>\n										<div class="list-item__row">\n											<div class="m-progress">\n											<div class="m-progress__indicator" style="width:'+
((__t=( calcBer(getSensorValue('signal_quality_ber')) ))==null?'':__t)+
'%;"></div>\n\n		 								</div>\n										</div>\n									</div>\n								</li>\n\n						';
 } 
__p+='\n\n						';
 if (hasSensor('power_factor')) { 
__p+='\n\n								<li class="m-sidebar-list__item">\n									<div class="list-item__inner">\n										<div class="list-item__row">\n											<span class="">Power factor</span>\n											<span class="align-right">'+
((__t=( getFloat(getSensorValue('power_factor')) ))==null?'':__t)+
'</span>\n										</div>\n\n										</div>\n									</div>\n								</li>\n\n						';
 } 
__p+='\n\n\n\n						';
 if (hasSensor('nfc')) { 
__p+='\n							<li class="m-sidebar-list__item">\n								<div class="list-item__inner">\n									<div class="list-item__row">\n										<span class="">nfc tag</span>\n										<span class="align-right">'+
((__t=( getSensorValue('nfc') ))==null?'':__t)+
'</span>\n									</div>\n								</div>\n							</li>\n\n						';
 } 
__p+='\n\n\n\n\n						';
 if (hasSensor('modbus_registers')) { 
__p+='\n							';
 var rhmRegisters = getRhmRegisters() 
__p+='\n							';
 var sensorValue  = getSensorValue('modbus_registers') 
__p+='\n							';
 for (var key in sensorValue) { 
__p+='\n								';
 for (var regKey in rhmRegisters) { 
__p+='\n									';
 if (key == rhmRegisters[regKey].regAddr) { 
__p+='\n									<!-- ugly way to define that the register may not be equal to temperature register or pressure register -->\n									';
 if (rhmRegisters[regKey].type != 9 && rhmRegisters[regKey].type != 10) 
__p+='\n										<!-- <li class="m-sidebar-list__item">\n											<div class="list-item__inner">\n												<div class="list-item__row">\n													<span class="">'+
((__t=( rhmRegisters[regKey].label ))==null?'':_.escape(__t))+
'</span>\n													<span class="align-right">'+
((__t=(

														getRhmValueByType (rhmRegisters[regKey].type, sensorValue[key])

														))==null?'':_.escape(__t))+
'</span>\n\n												</div>\n											</div>\n										</li> -->\n									';
 } 
__p+='\n								';
 } 
__p+='\n						    ';
 } 
__p+='\n						';
 } 
__p+='\n\n\n\n\n\n					</ul>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/device-status/show/templates/status.html
// module id = 428
// module chunks = 0